import DynamicPageComboBoxLogic from './dynamicPagesComboBoxLogic';
import React from 'react';
import createReactClass from 'create-react-class';
import type { Dispatch } from 'types/redux';
import * as platformEvents from 'platformEvents';
import { WIX_BLOG } from '@wix/app-definition-ids';

import type {
  TpaInnerRouteData,
  CurrentTpaInnerRoutesInfo,
} from '#packages/stateManagement';
import type { EditorState } from '#packages/stateManagement';
import * as stateManagement from '#packages/stateManagement';
import * as util from '#packages/util';
import * as core from '#packages/core';
import type { SitemapEntry } from 'types/documentServices';
import type { EditorAPI } from '#packages/editorAPI';
import { EditorPlatformHostIntegrationAPI } from '@wix/editor-platform-host-integration-apis';
import type { PageRef } from '@wix/document-services-types';
import type { RoutersDefinition } from '@wix/document-services-types';

const { getStageLayout } = stateManagement.domMeasurements.selectors;

const { getPreviewMode } = stateManagement.preview.selectors;

type InnerRoute = SitemapEntry | TpaInnerRouteData;

interface BiParams {
  item_path: string;
  item_id: string;
  app_id: string;
  infra: string;
  button_name?: string;
}

interface DynamicPagesComboBoxProps {
  innerRef: React.RefObject<React.ReactInstance>;
  previewMode: boolean;
  editorIsInit: boolean;
  devModeContext: unknown;
  stageLayout?: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
  innerRoutes: InnerRoute[];
  selectedInnerRoute?: string;
  routerId?: string;
  tpaInfo?: CurrentTpaInnerRoutesInfo;
  setSelectedInnerRoute: (innerRoute: string, routerId: string) => void;
  getDynamicPageNavBarConfig: (numberOfItems: number) => Promise<unknown>;
  notifyApplication: (actionId: string) => void;
  sendBI: (eventName: AnyFixMe, innerRouteName: string) => void;
  style?: React.CSSProperties;
  shouldOverrideInitPosition?: boolean;
  onDragStart?: () => void;
  onDragEnd?: () => void;
}
export const INFRA = {
  TPA_LINKS: 'tpa_link',
  DYNAMIC_PAGES: 'dynamic_pages',
};

// eslint-disable-next-line react/prefer-es6-class
const DynamicPagesComboBox = createReactClass<DynamicPagesComboBoxProps>({
  displayName: 'dynamicPagesComboBox',
  render() {
    const props = this.state.props || this.props;

    const Comp = DynamicPageComboBoxLogic;
    return <Comp {...props} ref={this.props.innerRef} />;
  },
  componentDidMount() {
    this.setState({ props: this.props });
  },
  componentDidUpdate(prevProps) {
    if (prevProps === this.props) {
      return;
    }

    this.setState({ props: this.props });

    const isBlogApp = this.props.tpaInfo?.appDefinitionId === WIX_BLOG;
    if (!isBlogApp) {
      return;
    }

    const selectedRouteExists = this.props.innerRoutes.some(
      (route: TpaInnerRouteData) =>
        route.path === this.props.selectedInnerRoute,
    );
    if (selectedRouteExists) {
      return;
    }

    const firstRoutePath = this.props.innerRoutes[0]?.path;
    if (firstRoutePath) {
      this.props.setSelectedInnerRoute(firstRoutePath, this.props.routerId);
    }
  },
  updateProps(props: Partial<DynamicPagesComboBoxProps>) {
    this.setState({ props: { ...this.state.props, ...props } });
  },
  mixins: [core.mixins.editorAPIMixin, util.draggableMixin],
});

const getDynamicPageParams = (
  innerRouteName: string,
  routerData: RoutersDefinition,
) => ({
  item_path: innerRouteName,
  item_id: routerData.prefix,
  app_id: routerData.appDefinitionId,
  infra: INFRA.DYNAMIC_PAGES,
});

const getTpaLinkParams = (editorAPI: EditorAPI, innerRouteName: string) => {
  const state = editorAPI.store.getState();
  const selectedRoute =
    stateManagement.tpaDynamicPages.selectors.getSelectedRouteInfo(state);
  const currentTpa =
    stateManagement.tpaDynamicPages.selectors.getCurrentRouteInfo(state);

  return {
    item_path: innerRouteName,
    item_id: selectedRoute.itemTypeIdentifier,
    app_id: currentTpa.appDefinitionId,
    infra: INFRA.TPA_LINKS,
  };
};

const getAppDefId = (editorAPI: EditorAPI) => {
  const currentPageId = editorAPI?.dsRead.pages.getPrimaryPageId();
  const routerData =
    editorAPI.dsRead.routers.getRouterDataForPageIfExist(currentPageId);
  const appDefId = routerData
    ? routerData.appDefinitionId
    : stateManagement.tpaDynamicPages.selectors.getCurrentRouteInfo(
        editorAPI.store.getState(),
      ).appDefinitionId;
  return appDefId;
};

const getInnerRoutesProps = (editorAPI: EditorAPI, state: EditorState) => {
  const routerId = stateManagement.dynamicPages.selectors.getRouterId(state);
  if (routerId) {
    return {
      innerRoutes: stateManagement.dynamicPages.selectors.getInnerRoutes(state),
      selectedInnerRoute:
        stateManagement.dynamicPages.selectors.getSelectedInnerRoute(state),
      routerId,
    };
  }

  const selectedInnerRoute =
    stateManagement.tpaDynamicPages.selectors.getSelectedRouteInfo(state)?.path;
  if (selectedInnerRoute) {
    const tpaInfo =
      stateManagement.tpaDynamicPages.selectors.getCurrentRouteInfo(state);
    return {
      innerRoutes:
        stateManagement.tpaDynamicPages.selectors.getFocusedInnerRoutes(
          editorAPI,
          state,
          tpaInfo.appDefinitionId,
          tpaInfo.pageId,
          'dynamicPagesNavBar',
        ),
      selectedInnerRoute,
      tpaInfo,
    };
  }

  return {
    innerRoutes: [] as InnerRoute[],
  };
};

const getEditorAPI = (
  dispatch: Dispatch,
  getState: EditorState,
  {
    editorAPI,
  }: {
    editorAPI: EditorAPI;
  },
) => editorAPI;

const mapDispatchToProps = (dispatch: AnyFixMe) => {
  const editorAPI: EditorAPI = dispatch(getEditorAPI);

  return {
    setSelectedInnerRoute: (newRoute: string, routerId: string) => {
      const platformAPI = editorAPI.host.getAPI(
        EditorPlatformHostIntegrationAPI,
      );
      const currentPageRef = editorAPI.pages.getReference(
        editorAPI.dsRead.pages.getCurrentPageId(),
      ) as PageRef;
      const isVariantOrReplacerPage =
        !!platformAPI.pageReplace.getOriginalPageRef(currentPageRef);

      if (routerId) {
        dispatch(
          stateManagement.dynamicPages.actions.setSelectedInnerRouteAndNavigate(
            newRoute,
            routerId,
            isVariantOrReplacerPage ? currentPageRef.id : undefined,
          ),
        );
      } else {
        dispatch(
          stateManagement.tpaDynamicPages.actions.setCurrentUrlToState(
            newRoute,
            true,
          ),
        );
      }
    },
    getDynamicPageNavBarConfig: async (numberOfItems: number) => {
      const appDefId = getAppDefId(editorAPI);

      const appApi = await editorAPI.platform.getAppEditorApi(appDefId);

      const currentPageRef = editorAPI.pages.getReference(
        editorAPI.dsRead.pages.getCurrentPageId(),
      ) as PageRef;
      const navBarConfig = await appApi?.getDynamicPageNavBarConfig({
        pageRef: currentPageRef,
        numberOfItems,
      });

      return navBarConfig;
    },
    notifyApplication: (actionId: string) => {
      if (!actionId) {
        return;
      }
      const appDefId = getAppDefId(editorAPI);

      editorAPI.platform.notifyApplicationByAppDefId(
        appDefId,
        platformEvents.factory.navBarMainActionClicked({
          actionId,
        }),
      );
    },
    sendBI: (
      eventName: AnyFixMe,
      innerRouteName: string,
      manageButtonValueIfClicked?: string,
    ) => {
      const currentPageId = editorAPI.dsRead.pages.getPrimaryPageId();
      const routerData =
        editorAPI.dsRead.routers.getRouterDataForPageIfExist(currentPageId);

      const biParams: BiParams = routerData
        ? getDynamicPageParams(innerRouteName, routerData)
        : getTpaLinkParams(editorAPI, innerRouteName);

      if (manageButtonValueIfClicked) {
        biParams.button_name = manageButtonValueIfClicked;
      }

      editorAPI.bi.event(eventName, biParams);
    },
  };
};

const mapStateToProps = ({
  state,
  editorAPI,
}: {
  state: EditorState;
  editorAPI: EditorAPI;
}) => ({
  ...getInnerRoutesProps(editorAPI, state),
  stageLayout: getStageLayout(state),
  isPreview: getPreviewMode(state),
});

const Connected = util.hoc.connect(
  util.hoc.STORES.EDITOR_API,
  mapStateToProps,
  mapDispatchToProps,
)(DynamicPagesComboBox);
Connected.pure = DynamicPagesComboBox;
export default Connected;

export type FullDynamicPagesComboBoxProps = React.ComponentProps<
  typeof Connected
>;
